import store from "../store";
import { ResolveBaseApiUrl } from "../utils/Utility";
import APIService from "./APIService";

const baseUrl = ResolveBaseApiUrl() + "Form/";

const formAPIService = new APIService(baseUrl);

export async function GetAllFormTemplates() {
  var url = "getallformtemplates";
  return await formAPIService.fetchData(url);
}

export async function AssignFormTemplateToCustomer(reqBody) {
  var url = "assignformtocustomer";
  return await formAPIService.putData(url, reqBody);
}

export async function GetFormTemplateById(id) {
  var url = "getformtemplatebyid?templateid=" + id;
  return await formAPIService.fetchData(url);
}

export async function GetCustomerForms(customerid) {
  var url = "getcustomerforms?customerid=" + customerid;
  return await formAPIService.fetchData(url);
}

export async function AssignFormToApplicant(body) {
  var url = "addformtoapplicant";
  return await formAPIService.putData(url, body);
}

export async function GetApplicantForm(token) {
  var url = "getapplicantform?token=" + encodeURIComponent(token);
  return await formAPIService.fetchData(url);
}

export async function UpdateApplicantForm(data) {
  var url = "updateapplicantform";
  return await formAPIService.patchData(url, data);
}

export async function GetCustomerAllApplicantForm(searchData) {
  var url = "getcustomerallapplicantform";
  return await formAPIService.postData(url, searchData);
}

export async function GetFormDetail(formid) {
  var url = "getapplicationdetail?applicationId=" + formid;
  return await formAPIService.fetchData(url);
}

export async function GetViewFormDetail(
  applicationid,
  templateid,
  customerid,
  mode
) {
  var customHeaders = {};
  if (mode != null) {
    if (mode.includes("download")) mode = "download";
    else if (mode.includes("view")) mode = "view";
    customHeaders = {
      UserEmail: store.getState().auth.useremail,
      Mode: mode,
    };
  }
  var url = `getapplicantdetail?applicationid=${applicationid}&templateid=${templateid}&customerid=${customerid}`;
  return await formAPIService.fetchData(url, customHeaders);
}

export async function SendReminder(applicant_form_id) {
  var url = `sendreminderemailtoapplicant?applicant_form_id=${applicant_form_id}`;
  return await formAPIService.fetchData(url);
}

export async function DeleteCustomerApplication(applicationId) {
  var url = "deleteapplication?applicationId=" + applicationId;
}

export async function UpdateAssignedForm(data) {
  var url = "updateassignedform";
  return await formAPIService.patchData(url, data);
}

export async function DeleteAssignedForm(mappingid) {
  var url = `deleteassignedform?mappingid=${mappingid}`;
  return await formAPIService.deleteData(url);
}
